import { Injectable } from '@angular/core';
import { OperationAccessService } from './operation-access.service';
import { ALL_MODULES } from './UserPermissions';

export { ALL_MODULES };

@Injectable({
  providedIn: 'root'
})
export class ModuleAccessService {

  constructor(private operationAccessService: OperationAccessService) { }

  hasAccess(moduleId: string): Promise<boolean> {
    return this.operationAccessService.hasModule(moduleId);
  }

  isSuperAdmin(): Promise<boolean> {
    return this.operationAccessService.isSuperAdmin();
  }

  getAllowedModuleIds(): Promise<string[] | typeof ALL_MODULES> {
    return this.operationAccessService.getAllowedModuleIds();
  }
}
